import { defineComponent } from 'vue';
import SubmitButtonCode from '@/presentation/components/import-file/submit-button/submit-button.code';

export default defineComponent({
	setup: () => {
		const code = new SubmitButtonCode();

		return {
			isDisabled: code.isDisabled,
			wrapUpProcess: code.wrapUpProcess.bind(code)
		};
	}
});
